export const GetSortStatusNumber = (status: string) => {
  if ("inProgress" === status) return 0;
  if ("completed" === status) return 1;
  if ("cancel" === status) return 2;
  return 999;
};
